<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="12px" style="height: 100%">
  <mat-icon (click)="incZoom()">zoom_in</mat-icon>
  <mat-slider [min]="minZoom" [max]="maxZoom" [(value)]="zoom" step="0.1" vertical (input)="zoomChanged($event.value)">
  </mat-slider>
  <mat-icon (click)="decZoom()">zoom_out</mat-icon>
  <mat-icon (click)="resetZoom()">my_location</mat-icon>
</div>
